// メッセージMap
export const MessageMap = {
    "action_cop_text": "選考結果",
    "action_uni_text": "本人意向確認",
    "entry_text": "応募依頼",
};
